import { Box, Grid, Typography, useTheme } from '@mui/material'
import React from 'react'
import { Trans, useTranslation } from 'react-i18next'

import { bookingManagementItem } from './items'

const BookingManagementSection: React.FC = () => {
  const theme = useTheme()
  const { t } = useTranslation()
  const data = bookingManagementItem()
  return (
    <Box
      sx={{ px: { sm: '7.5rem', xs: '0rem' } }}
      margin='0 auto'
      maxWidth='90rem'
      mb={{ xs: 5, md: 8.75 }}
      mt={{ xs: '1.8rem', md: '3.688rem' }}
    >
      <Typography
        variant='h2'
        sx={{ mb: 1, color: theme.palette.primary.main }}
        fontSize={{ xs: '2rem', md: '2.5rem' }}
        lineHeight={{ xs: '2.5rem', md: '3rem' }}
        fontWeight={600}
      >
        <Trans
          i18nKey='featuresPage.bookingManagement'
          components={{ highlight: <span style={{ color: theme.palette.publicPages.light }} /> }}
        />
      </Typography>

      <Typography
        variant='h5'
        sx={{ color: theme.palette.publicPages.colorThirteen }}
        fontSize={{ xs: '.8rem', md: '1rem' }}
        lineHeight={{ xs: '1.563rem', md: '1.563rem' }}
        fontWeight={400}
        mt={2}
      >
        {t('featuresPage.bookingManagementSubHeading')}
      </Typography>

      <Grid container spacing={2} justifyContent='center' mt='2.25rem'>
        {data.map((card, index) => (
          <Grid
            item
            xs={12}
            sm={6}
            md={4}
            key={index}
            display='flex'
            justifyContent='center'
            gap='0.125rem'
          >
            <Box
              sx={{
                border: `solid 0.063rem ${theme.palette.publicPages.colorFive}`,
                borderRadius: '1.25rem',
              }}
              paddingX={{ lg: '1.25rem', md: '1.125rem', sm: '0.6rem', xs: '1.125rem' }}
              paddingTop={{ lg: '1.25rem', md: '1.125rem', sm: '0.6rem', xs: '1.125rem' }}
              paddingBottom={{ lg: '0.375rem', md: '0rem', sm: '0rem' }}
              textAlign='left'
              width={{ lg: '24.188rem' }}
              minHeight={{ sm: '10.5rem' }}
            >
              <Box component='img' src={card.icon} />

              <Typography
                mt='1rem'
                sx={{
                  fontSize: { lg: '1.125rem', md: '0.875rem' },
                  lineHeight: { lg: '1.563rem', md: '0.75rem' },
                }}
              >
                {t(`featuresPage.${card.title}`)}
              </Typography>
              <Typography
                fontSize={{ lg: '0.875rem', md: '0.813rem' }}
                fontWeight='300'
                lineHeight={{ lg: '1.313rem', md: '1.125rem' }}
                mt='0.438rem'
                color={theme.palette.publicPages.colorThirteen}
                maxWidth='19.875rem'
                mb='1.125rem'
              >
                {t(`featuresPage.${card.description}`)}
              </Typography>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  )
}

export default BookingManagementSection
